<template>
    <b-container fluid>
        <hr/>
        <h3>Events</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_event_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New event
            </v-btn>
        </b-button-group>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="events" :fields="[
                    {key: 'name', sortable: true},
                    {key: 'projectName', sortable: true},
                    'delete'
                ]">
                <template slot="delete" slot-scope="data">
                    <b-button @click="deleteEvent(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <create-event v-bind:project_options="project_options"
                      @event-created="EventCreated"
                      @change-create-loading="loadingCreate = !loadingCreate">
        </create-event>
    </b-container>
</template>

<script>
    import EventRepository from '../../repositories/event.repository';
    import CreateEvent from './Create.vue';
    import ProjectRepository from "../../repositories/project.repository";

    export default {
        data() {
            return {
                events: [],
                loadingIndex: false,
                loadingCreate: false,
                projects: []
            }
        },
        components: {
            CreateEvent,
        },
        created() {
            this.loadingIndex = true;
            EventRepository.getAll().then(res => {
                this.events = res.data.events;
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false
            });
            ProjectRepository.getAll().then(res => {
                this.projects = res.data["hydra:member"];
            });
        },
        methods: {
            EventCreated(event) {
                this.events.push(event);
            },
            deleteEvent(event) {
                this.$emit('show-loading-pop-up', 'Deleting the selected event.');
                EventRepository.delete(event.name).then(res => {
                    this.$emit('reset-loading-pop-up');
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        // Remove the event from the local list to reflect the deletion.
                        this.events = this.events.filter(u => u.name !== event.name);
                        // Notify the user.
                        this.$bvToast.toast(`Event ${event.name} successfully deleted.`, {
                            title: `Event deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$bvToast.toast('Looks like something went wrong while deleting a event.', {
                            title: `Event deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                    console.error(error);
                    if (error.response.status === 409) {
                        this.$bvToast.toast("Couldn't delete the event, check if the event has any relations with Subscribers, Cron Subscriber or webhooks", {
                            title: `Event deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast("Something went wrong while deleting the event ont the server. Check if the event has any relations with Subscribers or Cron Subscriber", {
                            title: `Event deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                });
            }
        },
        computed: {
            project_options() {
                return this.projects.map(p => {
                    return {value: p.id, text: p.id + " - " + p.name};
                });
            }
        }
    }
</script>
